<script>
import { useI18n } from "vue-i18n";

export default {
  setup() {
    // I18n
    const { t } = useI18n();

    return {
      t,
    }
  },
};
</script>

<template>
</template>

<style lang="scss" scoped>
</style>
